'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialize = initialize;

var _logger = require('./logger');

var _logger2 = _interopRequireDefault(_logger);

var _facebookPixel = require('./facebook-pixel');

var _facebookPixel2 = _interopRequireDefault(_facebookPixel);

var _facebookAnalytics = require('./facebook-analytics');

var _facebookAnalytics2 = _interopRequireDefault(_facebookAnalytics);

var _googleAnalytics = require('./google-analytics');

var _googleAnalytics2 = _interopRequireDefault(_googleAnalytics);

var _twitterAdsPixel = require('./twitter-ads-pixel');

var _twitterAdsPixel2 = _interopRequireDefault(_twitterAdsPixel);

var _googleAdwords = require('./google-adwords');

var _googleAdwords2 = _interopRequireDefault(_googleAdwords);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initialize(config, callback) {
  if (!config) {
    return handleError(new Error('config is required.'), callback);
  }
  if (!config.label) {
    return handleError(new Error('config.label is required.'), callback);
  }

  var promises = [];
  var handlers = [];
  var tagManager = {
    page: function page() {
      handlers.forEach(function (handler) {
        try {
          handler({ type: 'page', label: config.label });
        } catch (error) {
          _logger2.default.error('Error on page() handler');
          _logger2.default.error(error);
        }
      });
    },
    track: function track(id) {
      var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      handlers.forEach(function (handler) {
        try {
          handler({ type: 'track', id: id, properties: properties, label: config.label });
        } catch (error) {
          _logger2.default.error('Error on page() handler');
          _logger2.default.error(error);
        }
      });
    },
    setUserId: function setUserId(userId) {
      handlers.forEach(function (handler) {
        try {
          handler({ type: 'setUserId', userId: userId });
        } catch (error) {
          _logger2.default.error('Error on setUserId() handler');
          _logger2.default.error(error);
        }
      });
    }
  };

  if (config['facebook-pixel']) {
    promises.push((0, _facebookPixel2.default)({ config: config['facebook-pixel'], handlers: handlers, window: window, document: document }));
  }

  if (config['facebook-analytics']) {
    promises.push((0, _facebookAnalytics2.default)({ config: config['facebook-analytics'], handlers: handlers, window: window, document: document }));
  }

  if (config['google-analytics']) {
    promises.push((0, _googleAnalytics2.default)({ config: config['google-analytics'], handlers: handlers, window: window, document: document }));
  }
  if (config['twitter-ads-pixel']) {
    promises.push((0, _twitterAdsPixel2.default)({ config: config['twitter-ads-pixel'], handlers: handlers, window: window, document: document }));
  }

  if (config['google-adwords']) {
    promises.push((0, _googleAdwords2.default)({ config: config['google-adwords'], handlers: handlers, window: window, document: document }));
  }

  Promise.all(promises).then(function () {
    if (callback) callback(null, tagManager);
    return tagManager;
  }).catch(function (error) {
    return handleError(error, callback);
  });

  return tagManager;
}

function handleError(error, callback) {
  if (callback) {
    return callback(error);
  }
  return Promise.reject(error);
}

exports.default = initialize;


//////////////////
// WEBPACK FOOTER
// ./~/auth0-tag-manager/lib/index.js
// module id = 2
// module chunks = 0